<template>

    <main class="home">

        <home-header v-if="'homepage_slider_repeater' in page['acf']" :home-header-params="page['acf']['homepage_slider_repeater']"></home-header>

        <tabbed-teaser v-if="showTabbedTeaser" :teaser-filter-params="teaserFilterParams"></tabbed-teaser>

    </main>

</template>

<script>

    // console.log('Home');

    import HomeHeader from './HomeHeader.vue';
    import TabbedTeaser from './TabbedTeaser.vue';

    export default {
        created(){
            // loader.dequeueUpdateTimeoutInMs = 500;
            // this.$root.events.$on('loaded', (id)=>{
            //     this.$set(this.childrenLoaded, id, true);
            // });
            this.load();
        },
        destroyed(){
        },
        mounted(){
        },
        components : {
            HomeHeader,
            TabbedTeaser
        },
        props : {
            'teaserFilterParams' : {
                default : {},
                type : Object,
            }
        },
        data(){
            return {
                // childrenLoaded : {},
                page : {
                  acf : {},
                },
                showTabbedTeaser: false
            };
        },
        metaInfo(){
            return {
                meta : [
                    {
                        vmid : 'description',
                        name : 'description',
                        content : this.page['acf']['meta_description'],
                    },
                    {
                        vmid : 'og:description',
                        property : 'og:description',
                        content : this.page['acf']['meta_og_description'],
                    },
                    {
                        vmid : 'og:image',
                        property : 'og:image',
                        content : this.page['acf']['meta_og_image_1200_630'],
                    },
                    {
                        vmid : 'og:image:alt',
                        property : 'og:image:alt',
                        content : this.page['acf']['meta_og_image_alt_text'],
                    },
                    {
                        vmid : 'og:title',
                        property : 'og:title',
                        content : this.page['acf']['meta_og_title'],
                    },
                ],
            };
        },
        methods : {
            load(){
                this.$root.promises.home
                    .then( response => {
                        this.page = response.data;
                        this.showTabbedTeaser = true;
                        this.teaserFilterParams['categories_exclude'] = 1;
                    })
                    .catch( error => {
                        console.log('error', error);
                    });

                window.setTimeout(()=>{
                    try {
                        // this.$ga.page(this.$route.fullPath);
                        this.$gtm.trackEvent({
                            event : 'Pageview',
                            url : this.$route.path.toLowerCase().replace(/\/$/, ""),
                        });
                        this.$gtm.trackEvent({
                            event : 'scrolldepth',
                            url : this.$route.path.toLowerCase().replace(/\/$/, ""),
                        });
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
        },
    }

</script>



// WEBPACK FOOTER //
// public/js/components/Home.vue